module.exports = __webpack_public_path__ + "img/info-prod-aprovado.f504ac24.svg";